import {Fragment, useEffect, useState, useContext} from 'react';

import LoginContext from '../../../../../store/login-context';
import classes from './BioIdFirst.module.scss';
import BackStep from '../General/BackStep/BackStep';
import bioIdImg from '../../../../../assets/icons/biometric-icon_2.svg';
import Skip from '../Skip/Skip';
import ProgressBar from '../ProgressBar/ProgressBar';

declare function Translate(key: string): string;
declare var _curLang: any;


const BioIdFirst = (props) => {
    const ctx = useContext(LoginContext);

    const handleYesClick = () => {
        props.setCurrentScreenStep(ctx.preRegScreenCollection.bioIdCode);
        props.AddUserStep(ctx.preRegScreenCollection.bioIdCode);
    };

    const handleNoClick = () => {
        props.setCurrentScreenStep(ctx.preRegScreenCollection.pibaNoCard);
        props.AddUserStep(ctx.preRegScreenCollection.pibaNoCard);
    };
    
    const onBackStepHandler = () => {
        props.prevScreen(); 
    }


    return(        
        <Fragment>  
            <ProgressBar pbWidth="68%"/>                     
            <div className={classes.container}>
                <div>
                    <BackStep prevStep = {onBackStepHandler} />
                
                    <div className={`preRegTitleBold ${classes.title}`}>{Translate('N_Login_Has_Bio_ID')}</div>
                    <div className={classes.desc_container}>
                        <div className={`preRegText ${classes.desc}`}>
                            <div>
                                {Translate('N_Login_Bio_ID_Desc')}
                            </div>
                            <div>
                                {Translate('N_Login_Bio_ID_Desc_2')}
                            </div>
                        </div>
                        <div className={classes.id_img}>
                            <img src={bioIdImg} alt="biometric id" />
                        </div>
                    </div>
                    <div className={classes.buttons_container}>
                        <button className={`${classes.btn_no} ${_curLang === 'en' || _curLang === 'ru' ? classes.btn_no_ltr : ''}`} id='bioIdNo' onClick={handleNoClick}>
                        <span>{Translate('N_General_No')}</span>                   
                        </button>
                        <button className={classes.btn_yes} id='bioIdYes' onClick={handleYesClick}>
                            <span>{Translate('N_General_Yes')}</span>                     
                        </button>
                    </div>
                    <div className={classes.buttons_container_mobile}>
                        <button className={classes.btn_yes} id='bioIdYesMobile' onClick={handleYesClick}>
                            <span>{Translate('N_General_Yes')}</span>                     
                        </button>
                        <button className={`${classes.btn_no} ${_curLang === 'en' || _curLang === 'ru' ? classes.btn_no_ltr : ''}`} id='bioIdNoMobile' onClick={handleNoClick}>
                            <span>{Translate('N_General_No')}</span>                   
                        </button>
                    </div>
                </div>
                <div className={classes.skip}>
                    <Skip/>
                </div>
            </div>              
        </Fragment>
    )
};
export default BioIdFirst ;